/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRemoteSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRemoteSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRemoteSessionIssuerSecurity = {
  option1?: GetRemoteSessionIssuerSecurityOption1 | undefined;
  option2?: GetRemoteSessionIssuerSecurityOption2 | undefined;
};

export type GetRemoteSessionIssuerRequest = {
  /**
   * The remote_session_issuer id.
   */
  id?: string | undefined;
  /**
   * The remote_session_issuer slug.
   */
  slug?: string | undefined;
  /**
   * The upstream issuer URL (e.g. https://login.linear.app). Returns the issuer this project would use for that URL, or 404 when none describes it.
   */
  issuer?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRemoteSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRemoteSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetRemoteSessionIssuerSecurityOption1$Outbound,
    GetRemoteSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getRemoteSessionIssuerSecurityOption1ToJSON(
  getRemoteSessionIssuerSecurityOption1: GetRemoteSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    GetRemoteSessionIssuerSecurityOption1$outboundSchema.parse(
      getRemoteSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRemoteSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRemoteSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetRemoteSessionIssuerSecurityOption2$Outbound,
    GetRemoteSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getRemoteSessionIssuerSecurityOption2ToJSON(
  getRemoteSessionIssuerSecurityOption2: GetRemoteSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    GetRemoteSessionIssuerSecurityOption2$outboundSchema.parse(
      getRemoteSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRemoteSessionIssuerSecurity$Outbound = {
  Option1?: GetRemoteSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: GetRemoteSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRemoteSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  GetRemoteSessionIssuerSecurity$Outbound,
  GetRemoteSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRemoteSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRemoteSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRemoteSessionIssuerSecurityToJSON(
  getRemoteSessionIssuerSecurity: GetRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    GetRemoteSessionIssuerSecurity$outboundSchema.parse(
      getRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type GetRemoteSessionIssuerRequest$Outbound = {
  id?: string | undefined;
  slug?: string | undefined;
  issuer?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRemoteSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  GetRemoteSessionIssuerRequest$Outbound,
  GetRemoteSessionIssuerRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    slug: z.optional(z.string()),
    issuer: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRemoteSessionIssuerRequestToJSON(
  getRemoteSessionIssuerRequest: GetRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    GetRemoteSessionIssuerRequest$outboundSchema.parse(
      getRemoteSessionIssuerRequest,
    ),
  );
}
